
/**
 * Tab class
 * @category Tab
 * @param  {String} _el='' 셀렉터
 * @example
 * new Tab('.module-tab-underline');
 */
class Tab{
    constructor( _el='' ){
        this.el = _el;
        this.setting();
        this.addEvents();
    }
    setting(){
        this.toggleStretch();
        this.focusActiveItem();
    }
    // 윈도우 크기보다 tab 크기가 작으면 is-stretch 클래스 추가
    toggleStretch(){
        const windowWidth = $(window).width();
        let tabWidth = 0;

        $(this.el).removeClass( 'is-stretch' );
        $.map( $(this.el).children(), item => {
            tabWidth += $(item).outerWidth();
        });
        
        if(tabWidth <= (windowWidth - 36)) {
            $(this.el).addClass( 'is-stretch' );
        }
    }

    // 활성화 탭이 윈도우 크기 밖에 위치하면 포커스 되도록 이동
    focusActiveItem(){
        const activeItem = $(this.el).children('.is-active');
        if(!activeItem.length)  return;
        const windowWidth = $(window).width();
        const activeItemOffset = activeItem.offset().left + activeItem.outerWidth();

        if(activeItemOffset >= windowWidth) {
            $(this.el).scrollLeft(activeItemOffset);
        }
    }
    addEvents(){
        $(window).on('resize', () => this.setting());
    }

} // end of class
export default Tab;